module.exports = __webpack_public_path__ + "public/MoreSection/2.jpg?c95a2bba";